import { Navigate, Route, Routes } from 'react-router-dom'
import { AppShell } from './components/AppShell'
import { PublicLayout } from './components/PublicLayout'
import {
  ApprovalsPage,
  AssetsPage,
  BrainPage,
  IntegrationsPage,
  IntelligencePage,
  ModulesPage,
  OnboardingPage,
  OverviewPage,
  SettingsPage,
  TasksPage,
  TeamPage,
  UsagePage,
  VentureStudioPage,
  WorkflowsPage,
} from './pages/AppPages'
import {
  HomePage,
  LegalReadinessPage,
  LoginPage,
  PlatformPage,
  PricingPage,
  RequestDemoPage,
  SecurityPage,
  SolutionsPage,
} from './pages/PublicPages'

function ProtectedApp() {
  const authenticated = localStorage.getItem('dawn-demo-session') === 'true'
  return authenticated ? <AppShell /> : <Navigate to="/login" replace />
}

export default function App() {
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/platform" element={<PlatformPage />} />
        <Route path="/solutions" element={<SolutionsPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/security" element={<SecurityPage />} />
        <Route path="/privacy" element={<LegalReadinessPage type="privacy" />} />
        <Route path="/terms" element={<LegalReadinessPage type="terms" />} />
      </Route>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/request-demo" element={<RequestDemoPage />} />
      <Route path="/onboarding" element={<OnboardingPage />} />
      <Route path="/app" element={<ProtectedApp />}>
        <Route index element={<Navigate to="overview" replace />} />
        <Route path="overview" element={<OverviewPage />} />
        <Route path="tasks" element={<TasksPage />} />
        <Route path="brain" element={<BrainPage />} />
        <Route path="workflows" element={<WorkflowsPage />} />
        <Route path="approvals" element={<ApprovalsPage />} />
        <Route path="modules" element={<ModulesPage />} />
        <Route path="integrations" element={<IntegrationsPage />} />
        <Route path="assets" element={<AssetsPage />} />
        <Route path="intelligence" element={<IntelligencePage />} />
        <Route path="venture-studio" element={<VentureStudioPage />} />
        <Route path="usage" element={<UsagePage />} />
        <Route path="team" element={<TeamPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
